import { IView } from './types';

export const getEnabledViewsBySortOrder = (views: IView[] = []): IView[] => {
  return [...views]
    .filter((view) => view.isEnabled)
    .sort((first, second) => first.sortOrder - second.sortOrder);
};
